



import { Component, Provide, Vue } from 'vue-property-decorator';
import { Version as VersionModel } from '@/model/version.model';

@Component
export default class Version extends Vue {
  version(): string {
    const version: VersionModel = require("@/version.json");
    return ` - Version ${version.major}.${version.minor}.${version.patch}`;
  }
}
